export enum LogoVariant {
    COLOR = 'color',
    WHITE = 'white'
}